import React, { FC, HTMLAttributes, memo, useEffect } from "react";
import styled from "styled-components";
import { imagePath } from "./image/util";
import { APPEAL_CONTENT_WIDTH } from "./calculation/theme";
import { useInView } from "react-intersection-observer";
import { Transition } from "react-transition-group";
import { TransitionStatus } from "react-transition-group/Transition";
import { useActivation } from "lib/hooks/useActivation";

export type Props = HTMLAttributes<HTMLDivElement>;
const SystemArea: FC<Props> = ({ ...props }) => {
  const [ref, inView] = useInView({ threshold: 0.7 });
  const [inViewFirstly, activateInView] = useActivation(false);
  useEffect(() => {
    if (inView) activateInView();
  }, [inView]);
  return (
    <Transition in={inViewFirstly} timeout={400}>
      {(status) => (
        <Root ref={ref} {...props}>
          <Title>アニメふるさと納税の仕組み</Title>
          <FlowArea $status={status}>
            <FlowImage />
          </FlowArea>
        </Root>
      )}
    </Transition>
  );
};
export default memo(SystemArea);

const FlowImage: FC<HTMLAttributes<HTMLPictureElement>> = ({ ...props }) => {
  return (
    <picture {...props}>
      <source media="(max-width: 960px)" srcSet={imagePath("/system/flow-sp.png")} />
      <img src={imagePath("/system/flow-pc.png")} alt="アニメふるさと納税の仕組み" width="100%" loading="lazy" />
    </picture>
  );
};

const Root = styled.div`
  @media screen and (max-width: 960px) {
    padding: 10vw 0;
  }
  @media screen and (min-width: 601px) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  @media screen and (min-width: 961px) {
    margin: 0 auto;
  }
`;
const Title = styled.div`
  font-size: 1.8em;
  color: #006836;
  text-align: center;
`;
const FlowArea = styled.div<{ $status: TransitionStatus }>`
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.35);
  transition: opacity 400ms ease-in-out;
  opacity: ${({ $status }) => ($status === "entering" || $status === "entered" ? "1" : "0")};
  visibility: ${({ $status }) => ($status === "entering" || $status === "entered" || $status === "exiting" ? "visible" : "hidden")};
  @media screen and (max-width: 600px) {
    margin: 5vw;
    padding: 5vw;
  }
  ${APPEAL_CONTENT_WIDTH};
  @media screen and (min-width: 601px) and (max-width: 960px) {
    margin: 5vw;
    padding: 5vw;
  }
  @media screen and (min-width: 961px) and (max-width: 1440px) {
    padding: 60px;
    margin: 20px;
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    padding: 60px;
    margin: 20px;
  }
  @media screen and (min-width: 1921px) {
    padding: 60px;
    margin: 20px;
  }
`;
